import React from "react";
import styles from "./ArticlesSection.module.scss";
import articleImage from "../../../assets/images/card-image.jpg";

const ArticlesSection = () => {
  return (
    <div className={styles.articlesSectionContainer}>
      <h1 className={styles.mainTitle}>Articles</h1>

      <div className={styles.articleList}>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={articleImage} alt="The Title Of The Article" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Article">
              The Title Of The Article
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={articleImage} alt="The Title Of The Article" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Article">
              The Title Of The Article
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={articleImage} alt="The Title Of The Article" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Article">
              The Title Of The Article
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
      </div>

      <div className={styles.viewAllCentered}>View All</div>
    </div>
  );
};

export default ArticlesSection;
